import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
  Radio,
  Modal
} from "antd";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import R2Footer from "../../../components/Footer";
import Courses from "./children/courses";
import VisibleField from "./children/visibleField";
import "./styles.scss";
// import MenuSetting from '../../../services/menuSetting';

const { Content } = Layout;

const MenuSettings = (props) => {
  const [ showCourse, setShowCourse]= useState('fields');


  return (
    <Layout className="u-page-layout">
      <Content className="page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
        <div className="head_section">
            <PageHeader className="page-header" title=" Menu Settings" style={{ background: "#f0f2f5" }} />
            <div>
              <Radio.Group
                size="large"
                value={showCourse}
                onChange={(e) => setShowCourse(e.target.value)}
              >
                <Radio.Button value="fields">Visible Fields</Radio.Button>
                <Radio.Button value="course">Courses</Radio.Button>
              </Radio.Group>
            </div>
        </div>
            {showCourse === 'course' ?
              <Courses
                {...props}
              />
              :
              <VisibleField {...props} />}
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};
const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(MenuSettings));
